// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"vehicle-image_imageContainer__AnJn8","image":"vehicle-image_image__Q79IN"};